<template>
  <nav :class="scrolled ? 'scroll' : ''">
    <div class="menu-icon">
        <span class="fas fa-bars" @click="openMenuBtn();"></span>
    </div>
    <div class="logo">
      <router-link to="/" tag="span" style="cursor: pointer">
        <v-img
          eager
          color="primary"
          src="@/assets/red_typo.png"
          max-width="150"
          max-height="40"
          alt="sportopia logo"
        ></v-img>
      </router-link>
      <!-- <img src="@/assets/red_typo.png" alt=""> -->
    </div>
    <form action="#">
      <input type="text" class="search-data" placeholder="Nos services" required>
      <button type="submit" class="fas fa-search"></button>
    </form>
    <div class="nav-items">
        <li><a href="#" class="loginBtn">Connexion</a></li>
        <li><a href="#" class="partenaireBtn">Partenaire</a></li>
    </div>
    <div class="search-icon" @click="searchBtn();">
        <span class="fas fa-search"></span>
    </div>
    <div class="cancel-icon" @click="cancelMenuBtn();">
        <span class="fas fa-times"></span>
    </div>
  </nav>
</template>

<script>
import "@/assets/css/main-css.css";
import { mapGetters } from "vuex";
export default {
  name: "app-header",
  data() {
    return {
      menuItems: [
        { icon: "", title: "Home", to: "/" }, 
      ],
      scrolled: false
    };
  },
  methods: {
    openMenuBtn(){
      const menuBtn = document.querySelector(".menu-icon span");
      const searchBtn = document.querySelector(".search-icon");
      const cancelBtn = document.querySelector(".cancel-icon");
      const items = document.querySelector(".nav-items");
      items.classList.add("active");
      menuBtn.classList.add("hide");
      searchBtn.classList.add("hide");
      cancelBtn.classList.add("show");
    },
    cancelMenuBtn(){
      const menuBtn = document.querySelector(".menu-icon span");
      const searchBtn = document.querySelector(".search-icon");
      const cancelBtn = document.querySelector(".cancel-icon");
      const items = document.querySelector(".nav-items");
      const form = document.querySelector("form");
      items.classList.remove("active");
      menuBtn.classList.remove("hide");
      searchBtn.classList.remove("hide");
      cancelBtn.classList.remove("show");
      form.classList.remove("active");
      cancelBtn.style.color = "rgb(34, 34, 34)";
    },
    searchBtn(){
      const form = document.querySelector("form");
      const searchBtn = document.querySelector(".search-icon");
      const cancelBtn = document.querySelector(".cancel-icon");
      form.classList.add("active");
      searchBtn.classList.add("hide");
      cancelBtn.classList.add("show");
    },
    onSideNav() {
      this.$store.dispatch("sideNavChanged");
    },
    onLogout() {
      this.$store.dispatch("logout");
    },
    photoConvert(url) {
      if (url === null || url === undefined) {
        return "https://sprint-app.com:3000/sprint_avatar.png";
      }
      if (url.startsWith("uploads")) return url;
      else return url + "?height=500";
    },
    handleScroll () {
      this.scrolled = window.scrollY > 0;
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    ...mapGetters({
      user: "user",
      loading: "loading",
      notifications: "notifications",
    }),
    userIsAuthenticated() {
      return this.user !== null && this.user !== undefined;
    },
  },
};
</script>

<style scoped>
nav{
  background: #f5f5f5;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding: 0 50px;
  position: sticky;
  top: 0;
  left:0;
  right: 0;
  z-index: 100;
}
nav .logo img{
  max-width: 180px;
}
nav .logo .v-image{
  margin: auto;
}
nav .nav-items{
  display: flex;
  flex: 1;
  padding: 0 0 0 40px;
  justify-content: flex-end;
}
nav .nav-items li{
  list-style: none;
  padding: 0 15px;
}
nav .nav-items li a{
  font-size: 17px;
  font-weight: 500;
  text-decoration: none;
}
nav .nav-items .loginBtn{
  color: #000;
}
nav .nav-items .partenaireBtn{
  color: #fff;
  background: #E91E24;
  padding: 10px 30px;
  border-radius: 50px;
}
nav form{
  display: flex;
  height: 40px;
  padding: 2px;
  background: transparent;
  min-width: 18%!important;
  border-radius: 2px;
  border: none;
  margin-left: 30px !important;
}
nav form .search-data{
  width: 60%;
  height: 100%;
  padding: 0 10px;
  color: rgb(34, 34, 34);
  font-size: 17px;
  border: none;
  font-weight: 500;
  background: none;
}
nav form .search-data:focus{
  border: none !important;
}
nav form button{
  padding: 0 15px;
  color: #777;
  font-size: 17px;
  background: transparent;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  margin-top: -2px !important;
}
nav .menu-icon,
nav .cancel-icon,
nav .search-icon{
  width: 40px;
  text-align: center;
  margin: 0 50px;
  font-size: 18px;
  color: rgb(34, 34, 34);
  cursor: pointer;
  display: none;
}
nav .menu-icon span,
nav .cancel-icon,
nav .search-icon{
  display: none;
}
@media (max-width: 1245px) {
  nav{
    padding: 0 50px;
  }
}
@media (max-width: 1140px){
  nav{
    padding: 0px;
  }
  nav .logo{
    flex: 2;
    text-align: center;
  }
  nav .nav-items{
    position: fixed;
    z-index: 99;
    top: 70px;
    width: 100%;
    left: -100%;
    height: 100%;
    padding: 10px 50px 0 50px;
    text-align: center;
    background: #14181f;
    display: inline-block;
    transition: left 0.3s ease;
  }
  nav .nav-items.active{
    left: 0px;
  }
  nav .nav-items li{
    line-height: 40px;
    margin: 30px 0;
  }
  nav .nav-items li a{
    font-size: 20px;
  }
  nav form{
    position: absolute;
    top: 80px;
    right: 50px;
    opacity: 0;
    pointer-events: none;
    transition: top 0.3s ease, opacity 0.1s ease;
  }
  nav form.active{
    top: 95px;
    opacity: 1;
    z-index: 10;
    pointer-events: auto;
  }
  nav form:before{
    position: absolute;
    content: "";
    top: -10px;
    right: 0px;
    width: 0;
    height: 0;
    z-index: -1;
    border: 10px solid transparent;
    border-bottom-color: #1e232b;
    margin: -20px 0 0;
  }
  nav form .search-data{
    width: 100%;
    color: #fff;
  }
  nav form:after{
    position: absolute;
    content: '';
    height: 60px;
    padding: 2px;
    background: #1e232b;
    border-radius: 2px;
    min-width: calc(100% + 20px);
    z-index: -2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  nav .menu-icon{
    display: block;
  }
  nav .search-icon,
  nav .menu-icon span{
    display: block;
  }
  nav .menu-icon span.hide,
  nav .search-icon.hide{
    display: none;
  }
  nav .cancel-icon.show{
    display: block;
  }
}
.content{
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
}
.content header{
  font-size: 30px;
  font-weight: 700;
}
.content .text{
  font-size: 30px;
  font-weight: 700;
}
.space{
  margin: 10px 0;
}

@media (max-width: 980px){
  nav .menu-icon,
  nav .cancel-icon,
  nav .search-icon{
    margin: 0 20px;
  }
  nav form{
    right: 30px;
  }
  nav .nav-items .loginBtn{
    color: #fff;
  }
  nav .nav-items .partenaireBtn{
    color: #fff;
    background: transparent;
    padding: 0px ;
  }
}
@media (max-width: 350px){
  nav .menu-icon,
  nav .cancel-icon,
  nav .search-icon{
    margin: 0 10px;
    font-size: 16px;
  }
}
.content{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.content header{
  font-size: 30px;
  font-weight: 700;
}
.content .text{
  font-size: 30px;
  font-weight: 700;
}
.content .space{
  margin: 10px 0;
}
</style>
